import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { CertificateService } from "./certificatesAPI";
import { CertificateData } from "./certificates.types";

/**
 * Certificate state
 */
interface CertificateState {
  certificates: CertificateData[];
  certificatesLoading: boolean;
  certificatesError: string | null;
}

/**
 * Certificate inital state
 */
const initialState: CertificateState = {
  certificates: [],
  certificatesLoading: false,
  certificatesError: null,
};

// Thunks for fetch certificate
export const fetchCertificates = createAsyncThunk('Certificate',
  async (_, thunkAPI) => {
    try {
      return await CertificateService.fetchCertificates();
    } catch (error: any) {
      const message = error.message || 'Failed to fetch certificates';
      return thunkAPI.rejectWithValue(message);
    }
  });

  /**
   * Certificate Slice 
   */
const certificateSlice = createSlice({
  name: 'certificates',
  initialState,
  reducers: {
    // Local (synchronous) reducers
  },
  extraReducers: builder => {
    // These handle async actions (like fetchUsers thunk)
    builder
      .addCase(fetchCertificates.pending, state => {
        state.certificatesLoading = true;
        state.certificatesError = null;
      })
      .addCase(fetchCertificates.fulfilled, (state, action: PayloadAction<CertificateData[]>) => {
        state.certificates = action.payload;
        state.certificatesLoading = false;
      })
      .addCase(fetchCertificates.rejected, (state, action) => {
        state.certificatesError =  action.payload as string;
        state.certificatesLoading = false;
      })
  }
});

export default certificateSlice.reducer;